import n from "vue";
var t = n.extend({
  name: "Can",
  functional: true,
  props: {
    I: String,
    do: String,
    a: [String, Function],
    an: [String, Function],
    this: [String, Function, Object],
    on: [String, Function, Object],
    not: Boolean,
    passThrough: Boolean,
    field: String
  },
  render: function n(t, r) {
    var e = r.props,
        i = r.children,
        o = r.parent,
        a = r.data;
    var u = e;
    var c = u.I || u.do;
    var s = u.of || u.an || u.a || u.this || u.on;
    if (!c) throw new Error("[Vue Can]: neither `I` nor `do` prop was passed in <Can>");
    var f = o.$can(c, s, u.field);
    var l = e.not ? !f : f;
    if (!e.passThrough) return l ? i : [];
    if (!a.scopedSlots || !a.scopedSlots.default) throw new Error("[Vue Can]: `passThrough` expects default scoped slot to be specified");
    return a.scopedSlots.default({
      allowed: l,
      ability: o.$ability
    });
  }
});
var r = new WeakMap();

function e(n, t) {
  if (r.has(t)) return r.get(t);
  var e = {
    t: true
  };
  var i = "function" === typeof n.observable ? n.observable(e) : new n({
    data: e
  });
  t.on("updated", function () {
    i.t = !i.t;
  });
  r.set(t, i);
  return i;
}

function i(n) {
  if (n) return {
    value: n
  };
  return {
    get: function n() {
      throw new Error("Please provide `Ability` instance either in `abilitiesPlugin` or in ComponentOptions");
    }
  };
}

function o(n, t) {
  Object.defineProperty(n.prototype, "$ability", i(t));
  n.mixin({
    beforeCreate: function n() {
      var t = this.$options,
          r = t.ability,
          e = t.parent;
      var i = r || (e ? e.$ability : null);
      if (i) Object.defineProperty(this, "$ability", {
        value: i
      });
    },
    methods: {
      $can: function t() {
        var r;
        var i = e(n, this.$ability);
        i.t = i.t;
        return (r = this.$ability).can.apply(r, arguments);
      }
    }
  });
}

export { t as Can, o as abilitiesPlugin };